<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.isWeekend.fromTimezone" title="From Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.isWeekend.fromFormat" title="From Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.isWeekend.fromLocale" title="From Locale" />
        </div>
        <div class="d-flex gap-5">
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">{{ $t('auto.dateIsWeekendWeekendDays') }}</div>
                <div class="weekend-days">
                    <a-checkbox-group v-model="clone.isWeekend.weekendDays">
                        <a-checkbox value="0">{{ $t('auto.dateIsWeekendSunday') }}</a-checkbox>
                        <a-checkbox value="6">{{ $t('auto.dateIsWeekendSaturday') }}</a-checkbox>
                        <a-checkbox value="5">{{ $t('auto.dateIsWeekendFriday') }}</a-checkbox>
                    </a-checkbox-group>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateIsWeekend.vue");
export default {
    name: "DateIsWeekend",
    components: { TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.isWeekend",
            inputs: [""],
            isWeekend: {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en",
                weekendDays: ["0", "6"] // Default: Saturday and Sunday
            }
        };
        if (!clone.isWeekend) {
            clone.isWeekend = {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en",
                weekendDays: ["0", "6"] // Default: Saturday and Sunday
            };
        }
        return {
            clone
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section,
        .locale-picker-section,
        .timezone-picker-section {
            width: 100%;
        }
    }

    .weekend-days {
        margin-top: 10px;
        
        .ant-checkbox-group {
            display: flex;
            gap: 15px;
        }
    }
}
</style> 